/**
 * Resuelve el ID numérico de fábrica (mr_factories) a partir del código del header.
 */
export function resolveLaborFactoryId(selectedFactoryCode, factoriesList) {
  if (!selectedFactoryCode || !Array.isArray(factoriesList) || factoriesList.length === 0) {
    return null;
  }
  const code = String(selectedFactoryCode).toUpperCase();
  const found = factoriesList.find((f) => {
    const c = (f.asset_code || f.assetCode || f.Code || f.code || f.name || '').toUpperCase();
    return c === code;
  });
  if (!found) return null;
  return found.id ?? found.ID ?? null;
}

export function getEmployeeDisplayName(employee) {
  if (!employee) return '';
  const first = employee.first_name || employee.primer_nombre || '';
  const last = employee.last_name || employee.apellido_paterno || '';
  const full = `${first} ${last}`.trim();
  return full || employee.name || employee.email || `ID ${employee.id}`;
}
